
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Blogger Program',
    howItWorks: 'How it works',

    step1Title: 'Create a quality review',
    step1Description: 'Record a video with a full review of SHOT bot. We recommend showing:',
    step1Item1: 'All bot features',
    step1Item2: 'Case openings',
    step1Item3: 'Main features',

    step2Title: 'Post on Instagram or TikTok',
    step2Description:
      'Post the video on your Instagram or TikTok account. Make sure to add hashtags: #cs_shot_bot #cs2. More views — more rewards!',

    step3Title: 'Contact us',
    step3Description: 'Send a link to your video in private messages to',
    step3Channel: 'SHOT Friends',

    step4Title: 'Get rewarded',
    step4DescriptionPrefix: 'After video verification you will receive',
    step4DescriptionMiddle: 'for',
    step4DescriptionViews: '100,000 views',
    step4DescriptionSuffix: 'Payouts from 10,000 views once a week. We will create a tracking table.',

    warningTitle: 'Important rules',
    warningCheck: '⚠️ Fraud check:',
    warningCheckText:
      'We carefully verify all views for authenticity. We use special tools to detect fake views.',
    warningBan: '🚫 Ban:',
    warningBanText: 'Accounts caught using fake views will be permanently banned without any payouts.',
    warningHonest: '✅ Honesty:',
    warningHonestText: 'Play fair — get consistent rewards for quality content!',

    contactTitle: 'How to participate',
    contactDescription:
      'To participate in the program, message SHOT Friends channel. Send a link to your social media and specify the number of subscribers and average views on your videos.',
    contactButton: 'Message SHOT Friends',
  },
  ru: {
    title: 'Программа для блогеров',
    howItWorks: 'Как это работает',

    step1Title: 'Создай качественный обзор',
    step1Description: 'Сними видео с полным обзором бота SHOT. Рекомендуем показать:',
    step1Item1: 'Весь функционал бота',
    step1Item2: 'Прокрутку кейсов',
    step1Item3: 'Основные возможности',

    step2Title: 'Опубликуй в Instagram или TikTok',
    step2Description:
      'Размести видео на своём аккаунте в Instagram или TikTok. Обязательно поставь хэштеги: #cs_shot_bot #cs2. Чем больше просмотров — тем больше вознаграждение!',

    step3Title: 'Напиши нам',
    step3Description: 'Отправь ссылку на своё видео в личные сообщения канала',
    step3Channel: 'SHOT Friends',

    step4Title: 'Получай награду',
    step4DescriptionPrefix: 'После проверки видео получишь',
    step4DescriptionMiddle: 'за',
    step4DescriptionViews: '100 000 просмотров',
    step4DescriptionSuffix: 'Выплаты от 10 000 просмотров 1 раз в неделю. Сделаем таблицу для учета.',

    warningTitle: 'Важные правила',
    warningCheck: '⚠️ Проверка на накрутку:',
    warningCheckText:
      'Мы тщательно проверяем все просмотры на подлинность. Используем специальные инструменты для выявления накрутки.',
    warningBan: '🚫 Блокировка:',
    warningBanText:
      'Аккаунты, замеченные в накрутке просмотров, будут заблокированы навсегда без каких-либо выплат.',
    warningHonest: '✅ Честность:',
    warningHonestText: 'Делай все честно — получай стабильные вознаграждения за качественный контент!',

    contactTitle: 'Как принять участие',
    contactDescription:
      'Чтобы принять участие в программе, напиши в личные сообщения канала SHOT Friends. Отправь ссылку на свои соц сети и укажи количество подписчиков и сколько в среднем набирают просмотров твои видео.',
    contactButton: 'Написать в SHOT Friends',
  },
  uz: {
    title: 'Blogerlar dasturi',
    howItWorks: 'Bu qanday ishlaydi',

    step1Title: 'Sifatli sharh yarating',
    step1Description: 'SHOT boti haqida toʻliq sharh videosini yozing. Koʻrsatishni tavsiya qilamiz:',
    step1Item1: 'Botning barcha funksiyalari',
    step1Item2: 'Keys ochish',
    step1Item3: 'Asosiy imkoniyatlar',

    step2Title: 'Instagram yoki TikTokda joylashtiring',
    step2Description:
      'Videoni Instagram yoki TikTok akkauntingizda joylashtiring. Xeshteglarni qoʻshishni unutmang: #cs_shot_bot #cs2. Koʻrishlar qancha koʻp boʻlsa, mukofot ham shuncha koʻp!',

    step3Title: 'Bizga yozing',
    step3Description: 'Videongizga havolani shaxsiy xabarlarda yuboring:',
    step3Channel: 'SHOT Friends',

    step4Title: 'Mukofot oling',
    step4DescriptionPrefix: 'Video tekshirilgandan soʻng',
    step4DescriptionMiddle: 'uchun',
    step4DescriptionViews: '100 000 koʻrish',
    step4DescriptionSuffix: 'olasiz! Haftada bir marta 10 000 koʻrishdan toʻlovlar. Hisobni yuritish uchun jadval yaratamiz.',

    warningTitle: 'Muhim qoidalar',
    warningCheck: '⚠️ Firibgarlikni tekshirish:',
    warningCheckText:
      'Biz barcha koʻrishlarni haqiqiyligi uchun sinchkovlik bilan tekshiramiz. Soxta koʻrishlarni aniqlash uchun maxsus vositalardan foydalanamiz.',
    warningBan: '🚫 Bloklash:',
    warningBanText:
      'Soxta koʻrishlar foydalangan akkauntlar hech qanday toʻlovsiz abadiy bloklanadi.',
    warningHonest: '✅ Halollik:',
    warningHonestText: 'Halol oʻynang — sifatli kontent uchun barqaror mukofotlar oling!',

    contactTitle: 'Qanday ishtirok etish mumkin',
    contactDescription:
      'Dasturda ishtirok etish uchun SHOT Friends kanaliga xabar yozing. Ijtimoiy tarmoqlaringizga havola yuboring va obunachilar soni hamda videolaringiz oʻrtacha qancha koʻrish toʻplayotganini koʻrsating.',
    contactButton: 'SHOT Friendsga yozish',
  },
  fa: {
    title: 'برنامه بلاگرها',
    howItWorks: 'چطور کار می‌کند',

    step1Title: 'یک ریویو باکیفیت بساز',
    step1Description: 'ویدیویی با ریویوی کامل ربات SHOT ضبط کن. پیشنهاد می‌کنیم این‌ها را نشان بدهی:',
    step1Item1: 'همه امکانات ربات',
    step1Item2: 'باز کردن کیس',
    step1Item3: 'قابلیت‌های اصلی',

    step2Title: 'در اینستاگرام یا تیک‌تاک بگذار',
    step2Description:
      'ویدیو را در اینستاگرام یا تیک‌تاکت بگذار. حتماً هشتگ‌ها را اضافه کن: #cs_shot_bot #cs2. بازدید بیشتر — جایزه بیشتر!',

    step3Title: 'با ما تماس بگیر',
    step3Description: 'لینک ویدیویت را در پیام خصوصی بفرست به',
    step3Channel: 'SHOT Friends',

    step4Title: 'جایزه بگیر',
    step4DescriptionPrefix: 'بعد از بررسی ویدیو می‌گیری',
    step4DescriptionMiddle: 'برای',
    step4DescriptionViews: '100,000 بازدید',
    step4DescriptionSuffix: 'پرداخت از 10,000 بازدید، هفته‌ای یک بار. یک جدول پیگیری می‌سازیم.',

    warningTitle: 'قوانین مهم',
    warningCheck: '⚠️ بررسی تقلب:',
    warningCheckText: 'همه بازدیدها را با دقت بررسی می‌کنیم. برای پیدا کردن بازدید تقلبی ابزار مخصوص داریم.',
    warningBan: '🚫 مسدودی:',
    warningBanText: 'حساب‌هایی که با بازدید تقلبی گرفته شوند برای همیشه و بدون هیچ پرداختی مسدود می‌شوند.',
    warningHonest: '✅ صداقت:',
    warningHonestText: 'منصفانه بازی کن — برای محتوای باکیفیت جایزه همیشگی بگیر!',

    contactTitle: 'چطور شرکت کنیم',
    contactDescription:
      'برای شرکت در برنامه به کانال SHOT Friends پیام بده. لینک شبکه اجتماعیت را بفرست و تعداد دنبال‌کننده و میانگین بازدید ویدیوهایت را بنویس.',
    contactButton: 'پیام به SHOT Friends',
  },
  pt: {
    title: 'Programa para criadores',
    howItWorks: 'Como funciona',

    step1Title: 'Faça um review de qualidade',
    step1Description: 'Grave um vídeo com um review completo do bot SHOT. Recomendamos mostrar:',
    step1Item1: 'Todas as funções do bot',
    step1Item2: 'Abertura de caixas',
    step1Item3: 'Principais recursos',

    step2Title: 'Publique no Instagram ou TikTok',
    step2Description:
      'Publique o vídeo na sua conta do Instagram ou TikTok. Não esqueça das hashtags: #cs_shot_bot #cs2. Quanto mais visualizações — maior a recompensa!',

    step3Title: 'Fale com a gente',
    step3Description: 'Mande o link do seu vídeo por mensagem privada para o canal',
    step3Channel: 'SHOT Friends',

    step4Title: 'Receba a recompensa',
    step4DescriptionPrefix: 'Depois da verificação do vídeo você recebe',
    step4DescriptionMiddle: 'a cada',
    step4DescriptionViews: '100.000 visualizações',
    step4DescriptionSuffix: 'Pagamentos a partir de 10.000 visualizações, uma vez por semana. Vamos criar uma tabela de acompanhamento.',

    warningTitle: 'Regras importantes',
    warningCheck: '⚠️ Verificação de fraude:',
    warningCheckText:
      'Verificamos com cuidado a autenticidade de todas as visualizações. Usamos ferramentas especiais para detectar visualizações falsas.',
    warningBan: '🚫 Banimento:',
    warningBanText: 'Contas flagradas com visualizações falsas serão banidas para sempre, sem nenhum pagamento.',
    warningHonest: '✅ Honestidade:',
    warningHonestText: 'Jogue limpo — receba recompensas constantes por conteúdo de qualidade!',

    contactTitle: 'Como participar',
    contactDescription:
      'Para participar do programa, mande mensagem privada para o canal SHOT Friends. Envie o link das suas redes sociais e informe o número de seguidores e a média de visualizações dos seus vídeos.',
    contactButton: 'Escrever para SHOT Friends',
  },
  tr: {
    title: 'İçerik üreticisi programı',
    howItWorks: 'Nasıl çalışır',

    step1Title: 'Kaliteli bir inceleme hazırla',
    step1Description: 'SHOT botunun tam incelemesini içeren bir video çek. Şunları göstermeni öneririz:',
    step1Item1: 'Botun tüm işlevleri',
    step1Item2: 'Kasa açılışları',
    step1Item3: 'Ana özellikler',

    step2Title: "Instagram'da ya da TikTok'ta paylaş",
    step2Description:
      "Videoyu Instagram ya da TikTok hesabında paylaş. Hashtag'leri eklemeyi unutma: #cs_shot_bot #cs2. Ne kadar çok izlenme — o kadar çok ödül!",

    step3Title: 'Bize yaz',
    step3Description: 'Videonun linkini özel mesajla şu kanala gönder:',
    step3Channel: 'SHOT Friends',

    step4Title: 'Ödülünü al',
    step4DescriptionPrefix: 'Video kontrol edildikten sonra',
    step4DescriptionMiddle: 'alırsın — her',
    step4DescriptionViews: '100.000 izlenme için',
    step4DescriptionSuffix: 'Ödemeler 10.000 izlenmeden itibaren, haftada 1 kez. Takip için bir tablo oluşturacağız.',

    warningTitle: 'Önemli kurallar',
    warningCheck: '⚠️ Sahte izlenme kontrolü:',
    warningCheckText:
      'Tüm izlenmelerin gerçekliğini dikkatle kontrol ediyoruz. Sahte izlenmeleri tespit etmek için özel araçlar kullanıyoruz.',
    warningBan: '🚫 Yasaklama:',
    warningBanText: 'Sahte izlenme kullandığı tespit edilen hesaplar, hiçbir ödeme yapılmadan kalıcı olarak yasaklanır.',
    warningHonest: '✅ Dürüstlük:',
    warningHonestText: 'Dürüst oyna — kaliteli içerik için düzenli ödül al!',

    contactTitle: 'Nasıl katılırım',
    contactDescription:
      'Programa katılmak için SHOT Friends kanalına özel mesaj yaz. Sosyal medya hesaplarının linkini gönder, takipçi sayını ve videolarının ortalama izlenmesini belirt.',
    contactButton: "SHOT Friends'e yaz",
  },
});
